var WDN = WDN || {};

if (typeof WDN.ImageComparison === "undefined") {
  WDN.ImageComparison = (function () {
    class WDNImageComparison extends HTMLElement {
      constructor() {
        super();
      }

      getSliderById(reqId) {
        return document.querySelector("[data-comparison-slider='" + reqId + "']");
      }

      setImageWidth(newWidth) {
        this.currentLoopImage.style.width = newWidth + "px";
      }

      setHalfWidthImage() {
        this.setImageWidth(this.currentImageWidth / 2);
      }

      setSliderInteractionState(newState) {
        this.isBeingInteracted = newState;
      }

      positionCustomSlider() {
        var imageWidth = this.currentImageWidth;
        var imageHeight = this.currentImageHeight;
        var sliderHeight = this.slider.getBoundingClientRect().height;
        var sliderWidth = this.slider.getBoundingClientRect().width;
        this.setSliderLeftPos(imageWidth / 2 - sliderWidth / 2);
      }

      setSliderLeftPos(newPosition) {
        if (!this.slider) return;
        this.slider.style.transform = 'translateX(' + newPosition + 'px)';
      }

      createSlider() {
        var newSlider = document.createElement("div");
        newSlider.setAttribute("data-comparison-slider", this.id);
        newSlider.setAttribute("data-keen-slider-clickable", "");
        newSlider.setAttribute("data-keen-slider-scrollable", "");
        newSlider.setAttribute("class", "slider--compare");
        this.currentLoopImage.parentNode.insertBefore(newSlider, this.currentLoopImage);
        this.slider = this.getSliderById(this.id);

        if (this.settings && this.settings.icon) {
          this.slider.innerHTML = `
            <div class="comparison-slider__circle">${this.settings.icon}</div>
          `;
        }
      }

      setupSlider() {
        if (!this.slider) {
          this.createSlider();
          this.positionCustomSlider();
          this.bindSlider();
          this.hasCustomSlider = true;
        } else {
          this.updateSliderBackground();
        }
      }

      updateSliderBackground() {
        if (this.slider && this.slider.tagName === "INPUT") {
          var perc = this.slider.value;
          var bgStyle = "background:linear-gradient(to right, rgb(51, 51, 51) 0%, rgb(51, 51, 51) " + perc + "%, rgb(216, 216, 216) " + perc + "%, rgb(216, 216, 216) 100%);";
          this.slider.style.cssText = bgStyle;
        }
      }

      setupImage() {
        this.setHalfWidthImage();
        this.setupSlider();
      }

      storeImageInfo(image) {
        this.currentLoopImage = image; // storing it on instance to prevent passing it around

        this.currentImageWidth = image.getBoundingClientRect().width;
        this.currentImageHeight = image.getBoundingClientRect().height;
      }

      setupImages() {
        this.isInitted = true;
        this.imageOverlays.forEach(function (image) {
          this.storeImageInfo(image);
          this.setupImage();
        }, this);
      }

      sliderOnRelease() {
        this.unbindWindow();
        this.setSliderInteractionState(false);

        if (this.hasCustomSlider) {
          this.positionSlider();
        }

        // Remove body class that prevents scroll
        this.bodyHasScroll(true);
      }

      bodyHasScroll(newState) {
        // Apply only on the small devices (not needed for large)
        if (window.innerWidth > 900) return;

        if (newState) {
          document.body.classList.remove("overflow--hidden");
          return;
        }
        document.body.classList.add("overflow--hidden");
      }

      getCursorPosition(e) {
        if (e) {
          e = e.changedTouches ? e.changedTouches[0] : e;
          var imageBoundingClient = this.currentLoopImage.getBoundingClientRect();
          var cursorCoor = e.pageX - imageBoundingClient.left;
          var cursorPosition = cursorCoor - window.pageXOffset;
        }

        return cursorPosition || false;
      }

      validateCursorPosition(position) {
        position < 0 ? (position = 0) : "";
        position > this.currentImageWidth ? (position = this.currentImageWidth) : "";
        return position;
      }

      getInputPercentage() {
        return parseInt(this.slider.value) / 100;
      }

      calculateWidthBasedOnInput() {
        var inputPercentage = this.getInputPercentage();

        return this.currentLoopImage.getBoundingClientRect().width * inputPercentage;
      }

      positionSlider() {
        var sliderLeftPos = this.currentLoopImage.getBoundingClientRect().width - this.slider.getBoundingClientRect().width / 2;
        this.setSliderLeftPos(sliderLeftPos);
      }

      slide(position) {
        // position will be false in case input triggered the event, but not the mouse move
        if (position) {
          this.positionSlider();
          this.updateSliderBackground();
        } else {
          var position = this.calculateWidthBasedOnInput();
        }
        this.setImageWidth(position);
      }

      moveSlider(e) {
        if (!this.isBeingInteracted) return;
        var cursorPosition = this.getCursorPosition(e);
        var validatedPosition = this.validateCursorPosition(cursorPosition); // prevents going outside of the parent
        this.slide(validatedPosition);
      }

      sliderOnInteraction(e) {
        this.setSliderInteractionState(true);
        this.moveSlider(e);
        this.bodyHasScroll(false);
      }

      sliderOnPress(e) {
        this.sliderOnInteraction(e);
      }

      setupListeners() {
        this.bindWindow();
      }

      bindSlider() {
        if (this.slider) {
          this.slider.addEventListener("mousedown", this.setupListeners.bind(this));
          this.slider.addEventListener("touchstart", this.setupListeners.bind(this));
        }
      }

      bindWindow() {
        window.addEventListener("mouseup", this.sliderOnReleaseBound);
        window.addEventListener("touchend", this.sliderOnReleaseBound);
        window.addEventListener("mousemove", this.sliderOnInteractionBound);
        window.addEventListener("touchmove", this.sliderOnInteractionBound);
      }

      unbindWindow() {
        window.removeEventListener("mouseup", this.sliderOnReleaseBound);
        window.removeEventListener("touchend", this.sliderOnReleaseBound);
        window.removeEventListener("mousemove", this.sliderOnInteractionBound);
        window.removeEventListener("touchmove", this.sliderOnInteractionBound);
      }

      setupCallbacks() {
        this.sliderOnPressBound = this.sliderOnPress.bind(this);
        this.sliderOnReleaseBound = this.sliderOnRelease.bind(this);
        this.sliderOnInteractionBound = this.sliderOnInteraction.bind(this);
      }

      windowOnResize() {
        this.setImageWidth(this.getBoundingClientRect().width);
        this.setupImages();
        if (this.hasCustomSlider) this.positionCustomSlider();
      }

      listenForResize() {
        window.addEventListener("window:resize", this.windowOnResize.bind(this));
      }

      bind() {
        this.setupCallbacks();
        this.bindSlider();
        this.listenForResize();
      }

      isLazyLoaded() {
        return this.wasLazyLoaded || (this.mainImage.complete && this.mainImage.naturalHeight !== 0);
      }

      onImageLazyLoad() {
        this.wasLazyLoaded = true;
        this.init();
      }

      listenForLazyLoad() {
        this.mainImage.addEventListener("load", this.onImageLazyLoad.bind(this));
      }

      validateKeenParent() {
        if (!this.keenParent) return;

        if (!this.keenParent.contains(this)) {
          this.keenParent = false;
          return;
        }

        this.keenParentID = this.keenParent.getAttribute("id");
      }

      init() {
        if (this.isInitted) return;
        this.validateKeenParent();
        this.setupImages();
        this.bind();
      }

      // Code starts here
      connectedCallback() {
        this.keenParent = this.closest(".keen-slider");

        this.id = this.getAttribute("data-id");
        this.mainImage = this.querySelector("[data-image] img");
        this.imageOverlays = this.querySelectorAll("[data-image-overlay]");
        this.isInitted = false;
        this.slider = this.getSliderById(this.id);

        this.settings = WDN.ImageCompareConfig;
        this.init();
      }
    }

    customElements.define("wdn-image-comparison", WDNImageComparison);

    return {};
  })();
}
